import type { ResourceItemData } from 'labstep-web/components/ResourceItem/Action/BulkCreate/Modal/type';
import type React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

type BatchCreateItemsContextType = {
  data: ResourceItemData[];
  setData: React.Dispatch<React.SetStateAction<ResourceItemData[]>>;
  dateFormats: Record<string, string>;
  setDateFormats: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >;
};

const BatchCreateItemContext = createContext<
  BatchCreateItemsContextType | undefined
>(undefined);

export const useBatchCreateItemContext = () => {
  const context = useContext(BatchCreateItemContext);
  if (!context) {
    return undefined;
  }
  return context;
};

export const BatchCreateItemProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [data, setData] = useState<ResourceItemData[]>([]);
  const [dateFormats, setDateFormats] = useState<
    Record<string, string>
  >({});

  const contextValue = useMemo(
    () => ({
      data,
      setData,
      dateFormats,
      setDateFormats,
    }),
    [data, dateFormats],
  );

  return (
    <BatchCreateItemContext.Provider value={contextValue}>
      {children}
    </BatchCreateItemContext.Provider>
  );
};
